export default [{ Id: 1, Value: '1', Text: 'Administrator', },
{ Id: 10, Value: '10', Text: 'Organization Administrator' },
{ Id: 20, Value: '20', Text: 'District Administrator' },
{ Id: 30, Value: '30', Text: 'Principal' },
{ Id: 31, Value: '31', Text: 'Assistant Principal' },
{ Id: 32, Value: '32', Text: 'School Leader or Counselor' },
{ Id: 40, Value: '40', Text: 'Master Teacher' },
{ Id: 41, Value: '41', Text: 'Lead Teacher' },
{ Id: 42, Value: '42', Text: 'Mentor Teacher' },
{ Id: 50, Value: '50', Text: 'Teacher' },
{ Id: 100, Value: '100', Text: 'Individual' }]


